<template>
  <transition name="fade">
    <div
      v-if="modal.isVisible"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
    >
      <!-- Modal Box -->
      <div
        class="relative bg-gradient-to-br from-spicy-mustard-50 to-mocha-mousse-50 border border-mocha-mousse-100 rounded-2xl shadow-xl max-w-lg w-full mx-4 p-8 flex flex-col gap-6 transform transition-all duration-300 scale-100"
      >
        <!-- Header -->
        <div
          class="flex items-center gap-3 border-b border-mocha-mousse-100 pb-3"
        >
          <div
            v-if="modal.icon"
            class="bg-gradient-to-br from-spicy-mustard-200 to-mocha-mousse-100 p-2 rounded-xl"
          >
            <Icon :icon="modal.icon" class="w-6 h-6 text-mocha-mousse-700" />
          </div>
          <h2 class="text-xl font-semibold text-mocha-mousse-800">
            {{ modal.title }}
          </h2>
        </div>

        <!-- Message -->
        <div v-if="modal.message" class="text-gray-700 leading-relaxed">
          {{ modal.message }}
        </div>

        <!-- Dynamic Content -->
        <div v-if="modal.content">
          <component :is="modal.content" v-bind="modal.props" />
        </div>

        <!-- Footer Buttons -->
        <div
          class="flex justify-end gap-3 pt-4 border-t border-mocha-mousse-100"
        >
          <button
            v-for="(btn, i) in modal.buttons"
            :key="i"
            @click="handleClick(btn)"
            class="px-5 py-2.5 rounded-xl font-medium shadow-sm transition-all duration-200 focus:outline-none flex items-center gap-2"
            :class="[
              btn.variant === 'danger'
                ? 'bg-gradient-to-r from-red-400 to-red-500 text-white hover:from-red-500 hover:to-red-600 focus:ring-4 focus:ring-red-100'
                : btn.variant === 'secondary'
                ? 'bg-white border-2 border-gray-200 text-gray-700 hover:border-gray-300 focus:ring-4 focus:ring-gray-100'
                : 'bg-gradient-to-r from-spicy-mustard-400 to-mocha-mousse-400 text-white hover:from-spicy-mustard-500 hover:to-mocha-mousse-500 focus:ring-4 focus:ring-spicy-mustard-100',
            ]"
          >
            <Icon v-if="btn.icon" :icon="btn.icon" class="w-4 h-4" />
            {{ btn.text }}
          </button>
        </div>

        <!-- Decorative Glow -->
        <div
          class="absolute -inset-0.5 rounded-2xl bg-gradient-to-br from-spicy-mustard-100 to-mocha-mousse-100 opacity-20 blur-lg -z-10"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from "vue";
import { useModalService } from "@/services/ModalService";
import { Icon } from "@iconify/vue";

const modalSvc = useModalService();
const modal = computed(() => modalSvc.modal);

function handleClick(btn) {
  if (typeof btn.action === "function") btn.action();
  if (btn.closeOnClick !== false) modalSvc.close();
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
